import { beautify, formatDateTime } from "../../utils/helpers";

export const useUSSDOutgoingLogs = () => {
  const tableColumns = () => [
    {
      id: "name",
      header: "Name",
      filter: {
        type: "text",
      },
    },
    {
      id: "session_id",
      header: "Session ID",
      filter: {
        type: "text",
      },
    },
    {
      id: "request",
      header: "Request",
      filter: {
        type: "text",
      },
    },
    {
      id: "response",
      header: "Name",
      filter: {
        type: "text",
      },
    },
    {
      id: "request_time",
      header: "Request Time",
      filter: {
        type: "text",
      },
    },
    {
      id: "response_time",
      header: "Response Time",
      filter: {
        type: "text",
      },
    },
    {
      id: "created_at",
      header: "Created At",
      filter: {
        type: "text",
      },
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        name: beautify(item?.name),
        request: beautify(item?.request),
        response: beautify(item?.response),
        request_time: formatDateTime(item?.request_time),
        response_time: formatDateTime(item?.response_time),
        created_at: formatDateTime(item?.created_at),
      };
    }),
  ];

  return {
    tableColumns,
    tableData,
  };
};
